/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rotate-popup[_ngcontent-%COMP%]{position:absolute;z-index:9999;top:0;bottom:0;left:0;right:0;display:none;flex-direction:column;justify-content:center;align-items:center;padding:3vw;background-color:rgba(0,0,0,.5)}@media screen and (max-aspect-ratio:1/1){.rotate-popup[_ngcontent-%COMP%]{display:flex}}.rotate-popup__text[_ngcontent-%COMP%]{text-align:center;font-size:1.5rem;margin-bottom:2rem;font-family:sb-montserrat,sans-serif}.rotate-popup__icon[_ngcontent-%COMP%]{max-width:40%;margin:0 auto}"];
export { styles as styles };
